import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const Jobs = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const mailtoLink = `mailto:info@cosmelytix.com?subject=Job Interest from ${encodeURIComponent(
      name
    )}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nMessage: ${message}`)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#2D1735] to-[#5f40a1] text-white">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-16 max-w-6xl">
        {/* Page Intro */}
        <section className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">Jobs</h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed mb-4">
            Thank you for your interest in joining our team! Currently, there are no open positions.
          </p>
          <p className="text-gray-200 max-w-3xl mx-auto leading-relaxed">
            However, you can register your interest by filling out the form below, and we will notify you if a suitable opportunity arises.
          </p>
        </section>

        {/* Form Section */}
        <section className="max-w-md mx-auto bg-white bg-opacity-10 backdrop-blur-md rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow">
          <h2 className="text-2xl font-semibold mb-6 text-[#E9A969] text-center">Register Your Interest</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-200 text-sm font-bold mb-2">
                Name:
              </label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Your Name"
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-200 text-sm font-bold mb-2">
                Email:
              </label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Your Email"
                required
              />
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-gray-200 text-sm font-bold mb-2">
                Message (Optional):
              </label>
              <textarea
                id="message"
                value={formData.message}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                rows="4"
                placeholder="Tell us about your skills and what you are looking for..."
              ></textarea>
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="px-8 py-3 rounded-full bg-gradient-to-r from-[#c58348] to-[#d69e5b] text-white font-semibold text-lg shadow-lg hover:scale-105 transform transition-all duration-300"
              >
                Submit
              </button>
            </div>
          </form>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Jobs;
